import {
    Box,
    Stack,
    Typography,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Space from "../Common/Space";
import DesktopGallery from "./DesktopGallery";
import ContactOwner from "./ContactOwner";
import React from "react";
import Chat from "../Chat/Chat";
import { conditionMap, danishKrone } from "./Post";
import {timestampToDateTime} from "../../Utilities/dateUtils";
import {Ad} from "../Ads/Ad";
import {bannerStore} from "../../Stores/BannerStore";
import {LinkSanitizerWrapper} from "./LinkSanitizerWrapper";
import { observer } from "mobx-react";
import {categoryStore} from "../../Stores/CategoryStore";
import {GetCustomFilterLabels} from "../../Utilities/postUtils";
import {PostFilters} from "./PostFilters";

export const PostDesktop = ({
    loading,
    scrollToMessageArea,
    post
}) => {
    const bannerLocation = "D3"
    const banner = bannerStore.banners[bannerLocation];
    const aspectRatio = "4/3";
    const levels = post.Category.levels
    const category = categoryStore.categoryList.find(category => category.id == post.CategoryId);

    const filters = [
        {label: "Tilstand", value: conditionMap[post.Condition]},
        {label: "Kategori", value: levels[`lvl${levels.lvls}`].name},
        ...((post.CustomFilters || [])
            .map(filter => {
                const labels = GetCustomFilterLabels(filter, category?.customFilters);
                return labels ? {label: labels.typeLabel, value: labels.valueLabel} : null;
            })
            .filter(Boolean))
    ];

    return <Box>
        {/* Title */}
        <Typography
            variant="h4"
            sx={{
                fontWeight: 'bold',
                marginTop: (!loading)
                    ? "10px"
                    : undefined
            }}
        >
            {post.Heading}
        </Typography>

        {/* Price and date */}
        <Stack spacing={1} direction="row" alignItems="center">
            <Typography alignItems="flex-start" variant="h4">
                {danishKrone.format(post.Price)}
            </Typography>
            <Stack
                spacing={1}
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{color: "#474747"}}
            >
                <CalendarMonthIcon fontSize="small"/>
                <Typography>{timestampToDateTime(post.CreationTime)}</Typography>
            </Stack>
        </Stack>
        <Space height="10px"/>

        <Box sx={{display: "inlineFlex",  justifyContent: 'space-between'}}>
            <Box flexGrow={1}>

                {/* Gallery */}
                <DesktopGallery gallery={post.Images}/>

                <Space height="20px"/>
                <Stack spacing={1}>
                    <PostFilters sx={{padding: "10px 0"}} filters={filters}/>

                    <LinkSanitizerWrapper text={post.Body} postId={post.PostId}/>

                    <Space height="10px"/>

                    <Box sx={{p: 1, borderRadius: 1}} id="postMessages">
                        <Chat post={post}/>
                    </Box>
                </Stack>

            </Box>

            {/* Sidebar */}
            <Space width="50px"/>
            <Box width={330}>
                <ContactOwner scrollToMessageArea={scrollToMessageArea} post={post}/>
                <Space height={"5px"}/>
                <Ad
                    banner={banner}
                    aspectRatio={aspectRatio}
                />
            </Box>
        </Box>
    </Box>
}

export default observer(PostDesktop);